const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';
const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';
const NON_ENGLISH_DIGIT_PATTERN = /[۰-۹٠-٩]/g;
const ENGLISH_DIGIT_PATTERN = /\d/g;

export function toEnglishDigits(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value).replace(NON_ENGLISH_DIGIT_PATTERN, char => {
    const persianIndex = PERSIAN_DIGITS.indexOf(char);
    if (persianIndex !== -1) {
      return String(persianIndex);
    }
    const arabicIndex = ARABIC_DIGITS.indexOf(char);
    if (arabicIndex !== -1) {
      return String(arabicIndex);
    }
    return char;
  });
}

export function toPersianDigits(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value).replace(ENGLISH_DIGIT_PATTERN, digit => PERSIAN_DIGITS[Number(digit)]);
}
